import FullScreen from 'core/components/layout/full-screen';

const GlobalErrorFrame = <template>
  <FullScreen class="global-error-frame" ...attributes as |FS|>
    <FS.Main>
      <:content>
        <div class="global-error-frame__content">
          {{yield to="content"}}
        </div>
      </:content>
      <:footer>
        <div class="global-error-frame__footer">
          {{yield to="footer"}}
        </div>
      </:footer>
    </FS.Main>
    {{#if (has-block "aside")}}
      <FS.Aside>
        {{yield to="aside"}}
      </FS.Aside>
    {{/if}}
  </FullScreen>
</template>;
export default GlobalErrorFrame;
